<template>
  <div class="form-container">
    <div class="card p-4">
      <h2 class="text-center mb-4">
        Registro de Usuarios
      </h2>
      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label
            for="nombre_usuario"
            class="form-label"
          >Nombre</label>
          <input
            id="nombre_usuario"
            v-model="nombre_usuario"
            type="text"
            class="form-control"
            placeholder="Introduce el nombre"
          >
          <div
            v-if="errors.nombre_usuario"
            class="text-danger"
          >
            {{ errors.nombre_usuario }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="apellidop"
            class="form-label"
          >Apellido Paterno</label>
          <input
            id="apellidop"
            v-model="apellidop"
            type="text"
            class="form-control"
            placeholder="Introduce el apellido paterno"
          >
          <div
            v-if="errors.apellidop"
            class="text-danger"
          >
            {{ errors.apellidop }}
          </div>
        </div>
        <div class="mb-3">
          <label
            for="apellidom"
            class="form-label"
          >Apellido Materno</label>
          <input
            id="apellidom"
            v-model="apellidom"
            type="text"
            class="form-control"
            placeholder="Introduce el apellido materno"
          >
          <div
            v-if="errors.apellidom"
            class="text-danger"
          >
            {{ errors.apellidom }}
          </div>
        </div>
  
       
  
       
  
        <div class="mb-3">
          <label
            for="rango_usuario"
            class="form-label"
          >Rango</label>
          <select
            id="rango_usuario"
            v-model="rango_usuario"
            class="form-control"
          >
            <option
              value=""
              disabled
            >
              Selecciona un rango
            </option>
            <option value="Administrador">
              Administrador
            </option>
            <option value="Administrativo">
             Administrativo
            </option>
            <option value="Costura">
              Costura
            </option>
           
            <option value="otro">
              Otro
            </option>
          </select>
          <div
            v-if="errors.rango_usuario"
            class="text-danger"
          >
            {{ errors.rango_usuario }}
          </div>
        </div>
  
      
  
        <div class="mb-3">
          <label
            for="permisos"
            class="form-label"
          >Permisos</label>
          <input
            id="permisos"
            v-model="permisos"
            type="number"
            class="form-control"
            placeholder="Introduce el numero de permiso"
          >
          <div
            v-if="errors.permisos"
            class="text-danger"
          >
            {{ errors.permisos }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="clave_registro"
            class="form-label"
          >Clave registro</label>
          <input
            id="clave_registro"
            v-model="clave_registro"
            type="number"
            class="form-control"
            placeholder="Introduce la clave"
          >
          <div
            v-if="errors.clave_registro"
            class="text-danger"
          >
            {{ errors.clave_registro }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="usuario"
            class="form-label"
          >Usuario</label>
          <input
            id="usuario"
            v-model="usuario"
            type="text"
            class="form-control"
            placeholder="Introduce el usuario"
          >
          <div
            v-if="errors.usuario"
            class="text-danger"
          >
            {{ errors.usuario }}
          </div>
        </div>
  
        <div class="mb-3">
          <label
            for="contrasena"
            class="form-label"
          >Contraseña</label>
          <input
            id="contrasena"
            v-model="contrasena"
            type="password"
            class="form-control"
            placeholder="Introduce la contraseña"
          >
          <div
            v-if="errors.contrasena"
            class="text-danger"
          >
            {{ errors.contrasena }}
          </div>
        </div>
  
  
        <button
          type="submit"
          class="btn btn-save w-100"
        >
          Guardar
        </button>
        <button
          type="button"
          class="btn btn-secondary w-100 mt-3"
          @click="goBack"
        >
          Regresar
        </button>
      </form>
  
      <p
        v-if="successMessage"
        class="text-success mt-3 text-center"
      >
        {{ successMessage }}
      </p>
      <p
        v-if="errorMessage"
        class="text-danger mt-3 text-center"
      >
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>
  
  <script>
  import axios from 'axios';
  import baseUrl from '../api'; // Asegúrate de que la ruta sea correcta
  
  export default {
    data() {
      return {
        nombre_usuario: '',
        apellidop: '',
        apellidom: '',

        rango_usuario: '',
        permisos: '',
        clave_registro: '',
        usuario: '',
        contrasena: '',
        successMessage: '',
        errorMessage: '',
        errors: {},
      
      };
    },
    methods: {
      validateForm() {
        this.errors = {};
        let valid = true;
     
        // Validaciones
        if (!this.nombre_usuario) {
          this.errors.nombre_usuario = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.apellidop) {
          this.errors.apellidop = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.apellidom) {
          this.errors.apellidom = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.rango_usuario) {
          this.errors.rango_usuario = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.permisos) {
          this.errors.permisos = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.clave_registro) {
          this.errors.clave_registro = 'Este campo es requerido.';
          valid = false;
        }
      
        if (!this.usuario) {
          this.errors.usuario = 'Este campo es requerido.';
          valid = false;
        }
        if (!this.contrasena) {
          this.errors.contrasena = 'Este campo es requerido.';
          valid = false;
        }
  
        return valid;
      },    goBack() {
    this.$router.push('/'); // Asegúrate de que Vue Router esté configurado
  },
      async submitForm() {
        console.log('submitForm called'); // Confirmar si la función se ejecuta

        if (!this.validateForm()) {
          return; // Detener el envío si hay errores

        }
  
        const data = {
          nombre_usuario: this.nombre_usuario,
          apellidop: this.apellidop,
          apellidom: this.apellidom,
          rango_usuario: this.rango_usuario,
          permisos: this.permisos,
          clave_registro: this.clave_registro, // Agregar tipo de evento
          usuario: this.usuario,
          contrasena: this.contrasena // Envía la contraseña sin encriptar
        };
        console.log("Datos enviados:", data); // Imprime los datos enviados

  
        try {
            const url = `${baseUrl}/api/registermisscoquette`; // Verifica que baseUrl sea correcto
            const response = await axios.post(url, data);
            console.log(url);

          if (response.data.success) {
            this.successMessage = 'Datos guardados correctamente.';
            this.errorMessage = '';
            this.resetForm(); // Opcional: resetear el formulario
          } else {
            this.errorMessage = response.data.message;
            this.successMessage = '';
          }
        } catch (error) {
          this.errorMessage = 'Ocurrió un error al guardar los datos.';
          this.successMessage = '';
          console.error(error);
        }
      },
      resetForm() {
        this.nombre_usuario = '';
        this.apellidop = '';
        this.apellidom = '';

        this.rango = '';
        this.permisos = '';
        this.clave_registro = '';
        this.usuario = ''; // Limpiar tipo de evento
        this.contrasena = '';
      
        this.errors = {}; // Limpiar errores
      }
    }
  };
  </script>
  
  <style scoped>
  .form-container {
    width: 100%;
    max-width: 600px;
    margin: 80px auto;
    padding: 20px;
  }
  
  .card {
    background-color: white;
    color: #333;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
  
  h2 {
    color: #343a40;
  }
  
  .form-label {
    color: #495057;
  }
  
  .btn-save {
    background-color: #28a745; /* Color verde */
    color: white;
    border: none;
    transition: background-color 0.3s, transform 0.3s;
  }
  
  .btn-save:hover {
    background-color: #218838; /* Verde más oscuro al pasar el mouse */
    transform: scale(1.05);
  }
  
  .text-danger {
    font-size: 0.875rem; /* Tamaño de texto más pequeño para mensajes de error */
  }
  </style>
  